module.exports = __webpack_public_path__ + "static/media/NAKKI LAKE SMALL AND BIG.cb49a61e.png";